import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const ISSUE_ENDPOINTS = {
  LIST: {
    method: 'GET',
    url: `${SERVER_API}/issues`,
  } as IEndpointData,
  LIST_PORTAL: {
    method: 'GET',
    url: `${SERVER_API}/portal/issues`,
  } as IEndpointData,
  /**
   * Создать черновик заявления
   */
  CREATE: {
    method: 'POST',
    url: `${SERVER_API}/issues`,
  } as IEndpointData,
  /**
   * Получить данные о заявлении
   *
   * @param {number} id
   * @returns {IEndpointData}
   */
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${SERVER_API}/issues/${id.toString()}`,
    };
  },
  /**
   * Отменить заявления
   *
   * @param {number} id
   * @returns {IEndpointData}
   */
  CANCEL(id: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${SERVER_API}/issues/${id.toString()}`,
    };
  },
  /**
   * Отменить заявления заявителем
   *
   * @param {number} id
   * @returns {IEndpointData}
   */
  CANCEL_BY_ISSUER(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${SERVER_API}/issues/${id.toString()}/cancel`,
    };
  },
  /**
   * Удалить заявление вместе с заявками ТМЦ
   *
   * @param {number} id
   * @returns {IEndpointData}
   */
  DELETE_WITH_TMC(id: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${SERVER_API}/issues/${id.toString()}`,
    };
  },
  /**
   * Получить значения полей для определенного этапа,
   * сгруппированные по секциям
   *
   * @param {number} issueId
   * @param {number} stepId - идентификатор этапа
   * @returns {IEndpointData}
   */
  GET_STEP_VALUES(issueId: number, stepId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${SERVER_API}/issues/${issueId.toString()}/step/${stepId.toString()}`,
    };
  },
  /**
   * Заполнить поля в определенной секции
   *
   * @param {number} issueId
   * @param {number} sectionId
   * @returns {IEndpointData}
   */
  FILL_ISSUE_SECTION(issueId: number, sectionId: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${SERVER_API}/issues/${issueId.toString()}/sections/${sectionId.toString()}/fill`,
    };
  },
  /**
   * Асинхорнный вариант заполнения значений полей секции
   *
   * Нужен исключительно для того что бы использовать при
   * автосохранении полей секций.
   *
   * @param {number} issueId
   * @param {number} sectionId
   * @returns {IEndpointData}
   * @constructor
   */
  FILL_ISSUE_SECTION_ASYNC(issueId: number, sectionId: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${SERVER_API}/issues/${issueId.toString()}/sections/${sectionId.toString()}/fill-async`,
    };
  },
  /**
   * Движения по состояниям бизнес-процесса
   *
   * @param {number} issueId
   * @param {number} transitionId
   * @returns {IEndpointData}
   */

  MOVE(issueId: number, transitionId?: number): IEndpointData {
    const transition = transitionId ? `/${transitionId.toString()}` : '';
    return {
      method: 'POST',
      url: `${SERVER_API}/issues/${issueId.toString()}/move${transition}`,
    };
  },
  /**
   * Получение маршрута
   *
   * @param {number} routeId
   * @returns {IEndpointData}
   */
  GET_ROUTE(routeId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${SERVER_API}/routes/${routeId.toString()}`,
    };
  },
  /**
   * Получение секций с прикрепленными к ним полями
   * для определенног этапа
   *
   * @param {number} stepId - идентификатор этапа
   * @returns {IEndpointData}
   */
  GET_SECTIONS: {
    method: 'GET',
    url: `${SERVER_API}/steps/sections`,
  } as IEndpointData,

  /**
   * Получение истории переходов заявления по шагам
   *
   * @param issueId
   * @returns {IEndpointData}
   */
  GET_STEP_CHANGES(issueId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${SERVER_API}/issues/${issueId.toString()}/step-changes`,
    };
  },

  /**
   * Получение информации о сроках дедлайна по заявлению
   *
   * @param issueId
   * @returns {IEndpointData}
   */
  GET_DEADLINES(issueId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${SERVER_API}/issues/${issueId.toString()}/deadlines`,
    };
  },

  /**
   * Получение постранично сообщений по данному заявлению
   * @param issueId
   * @returns {IEndpointData}
   */
  GET_MESSAGES(issueId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${SERVER_API}/issues/${issueId.toString()}/chat/messages`,
    };
  },

  /**
   * Отправка сообщения в рамках указанного заявления
   * @param issueId
   * @returns {IEndpointData}
   */
  SEND_MESSAGE(issueId: number): IEndpointData {
    return {
      method: 'POST',
      url: `${SERVER_API}/issues/${issueId.toString()}/chat/messages`,
    };
  },

  /**
   * Получение заполненного файла заявления. Данное файл может использоваться для последующей печати заявления и его подписи (для придания юридической значимости действиями с заявлением в раках системы). Подразумевается что подписанный файл пользователь прикрепит в одно из полей в рамках маршрута (скорее всего на первом же этапе).
   *
   * @param issueId
   * @param templateId
   * @returns {IEndpointData}
   */
  EXPORT_FILLED_TEMPLATE(issueId: number, templateId: number): IEndpointData {
    return {
      method: 'POST',
      url: `${SERVER_API}/issues/${issueId.toString()}/export-filled-template/${templateId.toString()}`,
    };
  },
  JOIN_CHAT(issueId: number): IEndpointData {
    return {
      method: 'POST',
      url: `${SERVER_API}/issues/${issueId.toString()}/chat/join`,
    };
  },
  DOCUMENT(issueId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${SERVER_API}/issues/${issueId.toString()}/documents`,
    };
  },
  /**
   * Общий отчет по мерам поддержки всех институтов развития в формате Excel
   */
  REPORT_FOR_ALL: {
    method: 'GET',
    url: `${SERVER_API}/reports/service/department/general-statistics`,
  } as IEndpointData,
  /**
   * Общий отчет по мерам поддержки указанного института развития формате Excel
   *
   * @param {number} departmentId
   * @returns {IEndpointData}
   * @constructor
   */
  REPORT_FOR_SPECIFIC(departmentId: number) {
    return {
      method: 'GET',
      url: `${SERVER_API}/reports/service/department/${departmentId}/general-statistics`,
    } as IEndpointData;
  },
  INTERVAL_STATISTICS: {
    method: 'GET',
    url: `${SERVER_API}/issues/interval-statistics`,
  } as IEndpointData,
  INTERVAL_STATISTICS_EXPORT: {
    method: 'GET',
    url: `${SERVER_API}/issues/interval-statistics-export`,
  } as IEndpointData,
};
